import general1 from "./general1.png";
import general2 from "./general2.png";
import general3 from "./general3.png";
import general4 from "./general4.png";

export const generals: {[keys: string]: any} = {
  general1,
  general2,
  general3,
  general4
}
